import {
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material';

type SwitchProps = Omit<MuiSwitchProps, 'color' | 'size'>;

const SWITCH_THUMB_SHADOW =
  '0 0 0 1px rgba(0, 0, 0, 0.04), 0 3px 8px 0 rgba(0, 0, 0, 0.15), 0 3px 1px 0 rgba(0, 0, 0, 0.06)';

const Switch = ({ sx, disabled, ...props }: SwitchProps) => {
  return (
    <MuiSwitch
      disableRipple
      disabled={disabled}
      {...props}
      sx={[
        {
          width: 51,
          height: 31,
          padding: 0,
          '& .MuiSwitch-switchBase': {
            padding: '2px',
            transitionDuration: '200ms',
            '&.Mui-checked': {
              transform: 'translateX(20px)',
              color: 'common.white',
              '& + .MuiSwitch-track': {
                bgcolor: 'global01.400',
                opacity: 1,
                border: 0,
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                bgcolor: 'global01.400',
                opacity: 0.4,
              },
            },
            '&.Mui-disabled': {
              '& .MuiSwitch-thumb': {
                color: 'common.white',
              },
              '& + .MuiSwitch-track': {
                opacity: 0.4,
              },
            },
          },
          '& .MuiSwitch-thumb': {
            width: 27,
            height: 27,
            boxShadow: SWITCH_THUMB_SHADOW,
          },
          '& .MuiSwitch-track': {
            borderRadius: 100,
            bgcolor: 'grey.700',
            opacity: 1,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default Switch;
